import React, { useState } from "react";
import { adminApi } from "../../utils/axiosConfig";

export default function DeleteProduct({ productId, onProductDeleted }) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleDelete = async () => {
    const confirmed = window.confirm(
      "Êtes-vous sûr de vouloir supprimer ce produit ? Cette action est irréversible."
    );
    if (!confirmed) return;

    setLoading(true);
    setError(null);

    try {
      await adminApi.delete(`/api/admin/products/${productId}`);

      if (onProductDeleted) onProductDeleted();
    } catch (err) {
      console.error("Erreur lors de la suppression :", err);
      const errorMsg =
        err.response?.data?.message ||
        err.response?.data?.error ||
        "Une erreur est survenue lors de la suppression du produit.";
      setError(errorMsg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <button
        onClick={handleDelete}
        disabled={loading}
        title="Supprimer ce produit définitivement"
        style={{
          padding: "6px 14px",
          backgroundColor: "red",
          color: "#fff",
          border: "none",
          borderRadius: 4,
          cursor: loading ? "not-allowed" : "pointer",
          fontWeight: "bold",
          fontSize: "0.8rem",
          lineHeight: 1,
          marginLeft: 10,
          opacity: loading ? 0.6 : 1,
        }}
      >
        {loading ? "Suppression..." : "🗑️ Supprimer"}
      </button>

      {error && <p style={{ color: "red", marginTop: 5 }}>{error}</p>}
    </>
  );
}
